import {SHOW_DETAIL_PAGE_LOADER, HIDE_DETAIL_PAGE_LOADER } from "../actions/actionConstants";

const initialState = {
  isLoading:false
};


export default function (state = initialState, action) {
  switch (action.type) {
    case SHOW_DETAIL_PAGE_LOADER:
        return Object.assign({}, state, { isLoading: true });
  
    case HIDE_DETAIL_PAGE_LOADER :
        return Object.assign({}, state, { isLoading: false})

    default:
      return state;
  }
}
